import React, { useState, useEffect } from 'react';
import { Modal, Input, message as antdMessage } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import axios from '../../config/axiosInstance';

const SendMessagePopup = ({ record, open, onClose }) => {
    const [messageTitle, setMessageTitle] = useState('Received message');
    const [customMessage, setCustomMessage] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            setMessageTitle('Received message');
            setCustomMessage('');
        }
    }, [open]);

    const handleSend = async () => {
        if (!customMessage.trim()) {
            antdMessage.warning('The message cannot be empty.');
            return;
        }

        setLoading(true);
        try {
            const endpoint =
                record.type === 'device'
                    ? '/ws/send-message-to-device'
                    : '/ws/send-message';

            const payload =
                record.type === 'device'
                    ? { deviceId: record._id, message: customMessage, title: messageTitle }
                    : { DeviceConfigId: record._id, message: customMessage, title: messageTitle };

            await axios.post(endpoint, payload);

            antdMessage.success(
                `Message sent to the ${record.type === 'device' ? 'device' : 'online devices of: ' + record.DeviceConfigName}`
            );
            onClose();
        } catch (error) {
            antdMessage.error(`Error sending message: ${error.response?.data?.message || 'Unknown error'}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={
                <span>
                    <MessageOutlined style={{ color: 'green', marginRight: 8 }} />
                    Send a message to:{' '}
                    <strong>{record?.DeviceConfigName || record?.Name || ''}</strong>
                </span>
            }
            open={open}
            onCancel={onClose}
            onOk={handleSend}
            confirmLoading={loading}
            okText="Send"
            cancelText="Cancel"
            destroyOnClose
        >
            <Input
                placeholder="Message title"
                value={messageTitle}
                onChange={(e) => setMessageTitle(e.target.value)}
                style={{ marginBottom: 12 }}
            />
            <Input.TextArea
                rows={4}
                placeholder="Write your message here..."
                value={customMessage}
                onChange={(e) => setCustomMessage(e.target.value)}
            />
        </Modal>
    );
};

export default SendMessagePopup;